/* Copyright (c) 2025 Xperi. All Rights Reserved. */

import { ScreenTaskControllerTypes } from '../../core/navigation';
import type { AppDispatch, TGetState } from '../../core/tivo/tivo-redux-wrapper';
import {
    GLOBAL_MOUSE_TRAP,
    onKeyBackPcPinOverlay,
    onKeyDigitPcPinOverlay,
    onKeyDownPcPinOverlay,
    onKeyLeftPcPinOverlay,
    onKeyOkPcPinOverlay,
    onKeyRightPcPinOverlay,
    onKeyUpPcPinOverlay,
    onMouseClickPcPinOverlay,
    onMouseOutPcPinOverlay,
    onMouseOverPcPinOverlay,
} from '../overlay/pcpinoverlay/pcpinoverlay.reducers';
import {
    dismissInfoCard,
    onKeyBackInfoCard,
    onKeyDownInfoCard,
    onKeyLeftInfoCard,
    onKeyOkInfoCard,
    onKeyRightInfoCard,
    onKeyUpInfoCard,
    onMouseClickInfoCard,
    onMouseOutInfoCard,
    onMouseOverInfoCard,
} from './infocard.reducers';

export const onKeyBackGlobalInfoCard = () => (dispatch: AppDispatch, getState: TGetState) => {
    const { screenTaskController } = getState().screens;
    switch (screenTaskController) {
        case ScreenTaskControllerTypes.PC_PIN_OVERLAY_TASK:
            dispatch(onKeyBackPcPinOverlay());
            dismissInfoCard();
            break;
        case ScreenTaskControllerTypes.GLOBAL_INFOCARD_CONTROLLER:
            dispatch(onKeyBackInfoCard());
            break;
        default:
            break;
    }
};

export const onKeyUpGlobalInfoCard = () => (dispatch: AppDispatch, getState: TGetState) => {
    const { screenTaskController } = getState().screens;
    switch (screenTaskController) {
        case ScreenTaskControllerTypes.PC_PIN_OVERLAY_TASK:
            dispatch(onKeyUpPcPinOverlay());
            break;
        case ScreenTaskControllerTypes.GLOBAL_INFOCARD_CONTROLLER:
            dispatch(onKeyUpInfoCard());
            break;
        default:
            break;
    }
};

export const onKeyDownGlobalInfoCard = () => (dispatch: AppDispatch, getState: TGetState) => {
    const { screenTaskController } = getState().screens;
    switch (screenTaskController) {
        case ScreenTaskControllerTypes.PC_PIN_OVERLAY_TASK:
            dispatch(onKeyDownPcPinOverlay());
            break;
        case ScreenTaskControllerTypes.GLOBAL_INFOCARD_CONTROLLER:
            dispatch(onKeyDownInfoCard());
            break;
        default:
            break;
    }
};

export const onKeyLeftGlobalInfoCard = () => (dispatch: AppDispatch, getState: TGetState) => {
    const { screenTaskController } = getState().screens;
    switch (screenTaskController) {
        case ScreenTaskControllerTypes.PC_PIN_OVERLAY_TASK:
            dispatch(onKeyLeftPcPinOverlay());
            break;
        case ScreenTaskControllerTypes.GLOBAL_INFOCARD_CONTROLLER:
            dispatch(onKeyLeftInfoCard());
            break;
        default:
            break;
    }
};

export const onKeyRightGlobalInfoCard = () => (dispatch: AppDispatch, getState: TGetState) => {
    const { screenTaskController } = getState().screens;
    switch (screenTaskController) {
        case ScreenTaskControllerTypes.PC_PIN_OVERLAY_TASK:
            dispatch(onKeyRightPcPinOverlay());
            break;
        case ScreenTaskControllerTypes.GLOBAL_INFOCARD_CONTROLLER:
            dispatch(onKeyRightInfoCard());
            break;
        default:
            break;
    }
};

export const onKeyOkGlobalInfoCard = () => async (dispatch: AppDispatch, getState: TGetState) => {
    const { screenTaskController } = getState().screens;
    switch (screenTaskController) {
        case ScreenTaskControllerTypes.PC_PIN_OVERLAY_TASK:
            dispatch(onKeyOkPcPinOverlay());
            break;
        case ScreenTaskControllerTypes.GLOBAL_INFOCARD_CONTROLLER:
            dispatch(onKeyOkInfoCard());
            break;
        default:
            break;
    }
};

export const onKeyDigitGlobalInfoCard = () => (dispatch: AppDispatch, getState: TGetState) => {
    const { screenTaskController } = getState().screens;
    if (screenTaskController === ScreenTaskControllerTypes.PC_PIN_OVERLAY_TASK)
        dispatch(onKeyDigitPcPinOverlay());
};

// ===============================================================================================
// BELOW LIST OF DISPATCHABLES ARE RELATED TO MOUSE EVENTS.
// ===============================================================================================

export const onMouseClickGlobalInfoCard = () => (dispatch: AppDispatch, getState: TGetState) => {
    const { screens, inputFactory } = getState();

    switch (screens.screenTaskController) {
        case ScreenTaskControllerTypes.PC_PIN_OVERLAY_TASK: {
            dispatch(onMouseClickPcPinOverlay());
            if (inputFactory.value === GLOBAL_MOUSE_TRAP) {
                dismissInfoCard();
            }
            break;
        }
        case ScreenTaskControllerTypes.GLOBAL_INFOCARD_CONTROLLER:
            dispatch(onMouseClickInfoCard());
            break;
        default:
            break;
    }
};

export const onMouseOutGlobalInfoCard = () => (dispatch: AppDispatch, getState: TGetState) => {
    const { screenTaskController } = getState().screens;
    switch (screenTaskController) {
        case ScreenTaskControllerTypes.PC_PIN_OVERLAY_TASK:
            dispatch(onMouseOutPcPinOverlay());
            break;
        case ScreenTaskControllerTypes.GLOBAL_INFOCARD_CONTROLLER:
            dispatch(onMouseOutInfoCard());
            break;
        default:
            break;
    }
};

export const onMouseOverGlobalInfoCard = () => (dispatch: AppDispatch, getState: TGetState) => {
    const { screenTaskController } = getState().screens;
    switch (screenTaskController) {
        case ScreenTaskControllerTypes.PC_PIN_OVERLAY_TASK:
            dispatch(onMouseOverPcPinOverlay());
            break;
        case ScreenTaskControllerTypes.GLOBAL_INFOCARD_CONTROLLER:
            dispatch(onMouseOverInfoCard());
            break;
        default:
            break;
    }
};

export const onMouseWheelGlobalInfoCard = (wheelDeltaY: number) => (dispatch: AppDispatch) => {
    if (wheelDeltaY > 0) {
        dispatch(onKeyUpGlobalInfoCard());
    } else if (wheelDeltaY < 0) {
        dispatch(onKeyDownGlobalInfoCard());
    }
};
